<span class="sh-1"[matTooltip]="toolTip" 
[matTooltipDisabled]="shortText==inputString"
[matTooltipPosition]="'above'" >
  {{shortText}}
</span>